import { useRoutingParameter } from "./useRoutingId"
import { selectDefaultWorkspaceId } from "features/data-management/workspace/context/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { useRouter } from "pages"
import { useEffect, useLayoutEffect } from "react"
import { SystemInitializingContainer } from "themes/default-tailwind/panels"

enum WorkspaceManagementMode {
    View = "view",
    Seats = "seats",
    Recent = "recent",
    Favorites = "favorites",
    Settings = "settings",
    Licenses = "licenses",
    AddOns = "add-ons",
    Admins = "admins",
    Integrations = "integrations",
    Home = "home",
    ContactLists = "contact-lists",
}

const replace = { replace: true }

export function LegacyWorkspaceRedirect() {
    const router = useRouter("/")
    const routingParamWorkspaceId = useRoutingParameter("workspaceId")
    const routingParamTagIds = useRoutingParameter("tagIds")
    const routingParamMode = useRoutingParameter("mode") as WorkspaceManagementMode
    const defaultWorkspaceId = useAppSelector((state) =>
        selectDefaultWorkspaceId(state, localStorage.getItem("recentWorkspace"))
    )
    useLayoutEffect(() => {
        if (routingParamWorkspaceId) {
            if (routingParamTagIds) {
                const tags = routingParamTagIds.split(",") || []
                router.navigate(
                    {
                        path: "/workspace/:workspaceId/explore/ws/*",
                        splat: tags.join("/"),
                        params: { workspaceId: routingParamWorkspaceId },
                    },
                    replace
                )
            } else if (routingParamMode) {
                switch (routingParamMode) {
                    case WorkspaceManagementMode.Home:
                        router.navigate(
                            {
                                path: "/workspace/:workspaceId",
                                params: { workspaceId: routingParamWorkspaceId },
                            },
                            replace
                        )
                        break
                    case WorkspaceManagementMode.Recent:
                        router.navigate(
                            {
                                path: "/workspace/:workspaceId/explore",
                                params: { workspaceId: routingParamWorkspaceId },
                            },
                            replace
                        )
                        break
                    case WorkspaceManagementMode.Favorites:
                        router.navigate(
                            {
                                path: "/workspace/:workspaceId/explore/favorites",
                                params: { workspaceId: routingParamWorkspaceId },
                            },
                            replace
                        )
                        break
                    case WorkspaceManagementMode.View:
                        router.navigate(
                            {
                                path: "/workspace/:workspaceId/explore/ws",
                                params: { workspaceId: routingParamWorkspaceId },
                            },
                            replace
                        )
                        break
                    case WorkspaceManagementMode.Seats:
                        router.navigate(
                            {
                                path: "/workspace/:workspaceId/settings/users",
                                params: { workspaceId: routingParamWorkspaceId },
                            },
                            replace
                        )
                        break
                    case WorkspaceManagementMode.Settings:
                        router.navigate(
                            {
                                path: "/workspace/:workspaceId/settings",
                                params: { workspaceId: routingParamWorkspaceId },
                            },
                            replace
                        )
                        break
                    case WorkspaceManagementMode.Admins:
                    case WorkspaceManagementMode.Licenses:
                    case WorkspaceManagementMode.AddOns:
                        router.navigate(
                            {
                                path: "/workspace/:workspaceId/settings/licenses",
                                params: { workspaceId: routingParamWorkspaceId },
                            },
                            replace
                        )
                        break
                    case WorkspaceManagementMode.Integrations:
                        router.navigate(
                            {
                                path: "/workspace/:workspaceId/settings/integrations",
                                params: { workspaceId: routingParamWorkspaceId },
                            },
                            replace
                        )
                        break
                    case WorkspaceManagementMode.ContactLists:
                        router.navigate(
                            {
                                path: "/workspace/:workspaceId/settings/contact-lists",
                                params: { workspaceId: routingParamWorkspaceId },
                            },
                            replace
                        )
                        break
                    default:
                        router.navigate(
                            {
                                path: "/workspace/:workspaceId",
                                params: { workspaceId: routingParamWorkspaceId },
                            },
                            replace
                        )
                }
            } else {
                router.navigate(
                    {
                        path: "/workspace/:workspaceId",
                        params: { workspaceId: routingParamWorkspaceId },
                    },
                    replace
                )
            }
        } else if (defaultWorkspaceId) {
            router.navigate(
                { path: "/workspace/:workspaceId", params: { workspaceId: defaultWorkspaceId } },
                replace
            )
        }
    }, [defaultWorkspaceId, router, routingParamMode, routingParamTagIds, routingParamWorkspaceId])
    return <SystemInitializingContainer />
}

export function LegacyProjectRedirect() {
    const router = useRouter("/")
    const projectId = useRoutingParameter("id")
    useEffect(() => {
        if (!projectId) {
            router.navigate({ path: "/" }, replace)
            return
        }
        router.navigate({ path: "/project/:projectId", params: { projectId } }, replace)
    }, [projectId, router])
    return <SystemInitializingContainer />
}
